import {
  getDocumentSharingInfoService,
  updateDocumentSharingService,
  addSharedDocumentComment,
  deleteSharedDocumentServices,
  submitMasterDocumentService,
  getRecipientOfSharedDocumentService,
} from "./sharedDocumentServices";

/*
    =============================================
        Get Shared Document Informantion
    =============================================
*/
export const fetchDocumentSharing = docID => dispatch =>
  new Promise((resolve, reject) => {
    getDocumentSharingInfoService(docID)
      .then(response => {
        dispatch({
          type: "DOCUMENT_SHARING_INFORMATION",
          payload: response.Users,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

/*
    =============================================
        Update Shared Document Informantion
    =============================================
*/
export const updateDocumentSharing = (docID, data) => dispatch =>
  new Promise((resolve, reject) => {
    updateDocumentSharingService(docID, data)
      .then(response => {
        dispatch({
          type: "UPDATE_DOCUMENT_SHARING_INFORMATION",
          payload: response.Users,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const initSharedDocumentData = payload => dispatch => {
  dispatch({
    type: "INIT_SHARED_DOCUMENT_DATA",
    payload,
  });
};

export const deleteSharedDocument = sharingHash => dispatch =>
  new Promise((resolve, reject) => {
    deleteSharedDocumentServices(sharingHash)
      .then(response => {
        dispatch({
          type: "REMOVE_SHARED_DOCUMENT",
          payload: sharingHash,
        });
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createSharedDocumentNote = data => () =>
  new Promise((resolve, reject) => {
    addSharedDocumentComment(data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const submitMasterDocumentAction =
  (sharingHash, docName, payload) => dispatch =>
    new Promise((resolve, reject) => {
      submitMasterDocumentService(sharingHash, docName, payload)
        .then(response => {
          dispatch({
            type: "SUBMITTED_MASTER_DOCUMENT",
            payload: sharingHash,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
export const recipientDocAcceptRejectAction = (type, flag) => dispatch => {
  dispatch({
    type: "RECIPIENT_DOC_ACCEPT_REJECT",
    payload: {
      type,
      flag,
    },
  });
};

export const getRecipientOfSharedDocumentAction =
  (sharingHash, docName) => dispatch =>
    new Promise((resolve, reject) => {
      getRecipientOfSharedDocumentService(sharingHash, docName)
        .then(response => {
          dispatch({
            type: "GET_SHARED_RECIPIENT_DOCUMENT",
            payload: response.collaborators,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
